var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIdentity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4444 1H2.55556C1.7 1 1 1.7 1 2.55556V8C1 8.85556 1.7 9.55556 2.55556 9.55556H13.4444C14.3 9.55556 15 8.85556 15 8V2.55556C15 1.7 14.3 1 13.4444 1ZM13.4444 5.66667H10.3333C10.3333 6.92667 9.26 8 8 8C6.74 8 5.66667 6.92667 5.66667 5.66667H2.55556V2.55556H13.4444V5.66667ZM10.3333 11.1111H15V13.4444C15 14.3 14.3 15 13.4444 15H2.55556C1.7 15 1 14.3 1 13.4444V11.1111H5.66667C5.66667 12.4022 6.70889 13.4444 8 13.4444C9.29111 13.4444 10.3333 12.4022 10.3333 11.1111Z",
    fill: "currentcolor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdentity);
export default __webpack_public_path__ + "static/media/identity.9b5c3d6f51f77c30f7b7d1f30e125810.svg";
export { ForwardRef as ReactComponent };